<template>
  <div class="table-responsive">
    <table class="table table-bordered align-middle hos-table">
      <thead>
        <tr>
          <th class="text-start">{{ nameHeader }}</th>
          <th class="text-end">Target</th>
          <th class="text-end">Actual</th>
          <th class="text-end">Variance</th>
          <th class="text-end">Percentage</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in rows" :key="index">
          <td class="text-start hos-name-cell">{{ row.name }}</td>
          <td class="text-end hos-metric-qty">{{ formatQty(row.target_qty) }}</td>
          <td class="text-end hos-metric-qty">{{ formatQty(row.actual_qty) }}</td>
          <td class="text-end hos-metric-qty" :class="varianceClass(row.variance_qty)">{{ formatQty(row.variance_qty) }}</td>
          <td class="text-end hos-metric-qty" :class="varianceClass(row.variance_qty)">{{ formatPercentage(row.percentage) }}</td>
        </tr>
        <tr v-if="! rows || ! rows.length">
          <td colspan="5" class="hos-empty-row">No data found for the selected filters.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { computed } from "vue";
import figureFormatter from "@/services/utils/figureFormatter";

const { onlyCommaFormat } = figureFormatter()

const props = defineProps({
  rows: Array,
  groupBy: String
})

const nameHeader = computed(() => {
  if (props.groupBy === 'item') return 'Item Name'
  return 'Category Name'
})

const formatQty = (value) => {
  if (value === null || value === undefined || value === '') return onlyCommaFormat(0)
  return onlyCommaFormat(value)
}

const formatPercentage = (value) => {
  if (value === null || value === undefined || value === '') return '0%'
  return `${Number(value)}%`
}

const varianceClass = (value) => {
  if (Number(value) < 0) return 'hos-metric-negative'
  return 'hos-metric-positive'
}
</script>

<style scoped>
.hos-table {
  font-size: 12px;
}

.hos-table thead th {
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8a8894;
  background-color: #f8f9fb;
}

.hos-name-cell {
  font-size: 13px;
  font-weight: 600;
  color: #2b2b2b;
}

.hos-metric-qty {
  font-size: 13px;
  font-weight: 700;
  color: #2b2b2b;
  line-height: 1.3;
}

.hos-metric-positive {
  color: #16a085;
}

.hos-metric-negative {
  color: #ea5455;
}

.hos-empty-row {
  text-align: center;
  color: #9a98a3;
  font-size: 12px;
  padding: 28px 0;
}
</style>
